import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { getCSSColorFill, getCSSColorPolygonFill } from '~/utilities/getCSS';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';

const polygonClasses = cva('ease duration-300', {
  variants: {
    color: getCSSColorFill(),
    polygonColor: getCSSColorPolygonFill(),
    type: {
      chevron: 'w-4',
      triangle: 'w-2.5',
    },
    active: {
      true: 'rotate-180',
      false: '',
    },
  },
});

type DropdownIconType = {
  active: boolean;
  activeColor?: COLOR;
  color: COLOR;
  type?: 'chevron' | 'triangle';
};

export default component$(
  ({
    color,
    active,
    activeColor,
    type = 'chevron',
  }: DropdownIconType): JSX.Element => {
    if (type === 'triangle') {
      return (
        <svg
          class={polygonClasses({
            color: active && activeColor ? activeColor : color,
            polygonColor: active && activeColor ? activeColor : color,
            type,
            active,
          })}
          width='64'
          height='10px'
          viewBox='0 0 64 64'
          version='1.1'
        >
          <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
            <polygon points='0 16 32 48 64 16' />
          </g>
        </svg>
      );
    }

    return (
      <svg
        class={polygonClasses({
          color: active && activeColor ? activeColor : color,
          polygonColor: active && activeColor ? activeColor : color,
          type,
          active,
        })}
        width='16'
        height='16'
        viewBox='0 0 16 16'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g fill-rule='evenodd'>
          <path
            d='M11,8.09909655 L6.5,13 L5,11.3663655 L8.09099026,8 L5,4.63363448 L6.5,3 L11,7.90090345 L10.9090097,8 L11,8.09909655 Z'
            fill-rule='nonzero'
            transform='rotate(90 8 8)'
          />
        </g>
      </svg>
    );
  }
);
